import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        margin: 10
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    }
});

class TestComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar}></div>
                Això és només un test
            </div>
        );
    };
};


TestComponent.propTypes = {
    //state
    user: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        //TODO
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(TestComponent));